module.exports = __webpack_public_path__ + "static/media/Rorventiler.66ade63f.jpg";